import { WorkTimeReportDTO } from 'api/model';
import { toDateOnlyString } from 'utils/date-helpers';

// Datumen i tidsrapporten är svenska kalenderdagar som backend skickar som "ÅÅÅÅ-MM-DD". Orval-
// mutatorns handleDates() gör om sådana strängar till Date trots string-typen (samma sak som för
// LAS-dagarna, se normalizeLasDays), så de görs om till strängar igen här. Start- och sluttid
// ("ÅÅÅÅ-MM-DD TT:MM", utan sekunder) matchar inte mutatorns mönster och lämnas orörda.
export const normalizeWorkTimeReport = (
  report: WorkTimeReportDTO
): WorkTimeReportDTO => ({
  ...report,
  from: report.from ? toDateOnlyString(report.from) : undefined,
  to: report.to ? toDateOnlyString(report.to) : undefined,
  rows: report.rows.map((r) => ({ ...r, date: toDateOnlyString(r.date) })),
  availability: (report.availability ?? []).map((d) => ({
    ...d,
    date: toDateOnlyString(d.date),
  })),
});

/**
 * Anställningsnumret jämfört utan mellanslag, som backend (FindUserIdByEmploymentId) och
 * Hogia-exporten: "12 345" och "12345" är samma nummer. Tom sökning matchar ingen.
 */
export const matchesEmploymentId = (
  employmentID: string | null | undefined,
  query: string
): boolean => {
  const normalizedQuery = query.replace(/ /g, '');
  if (!normalizedQuery || !employmentID) return false;
  return employmentID.replace(/ /g, '') === normalizedQuery;
};

/**
 * Minuter som decimaltimmar med två decimaler, som HR räknar med: 75 → "1,25". Tomt när värdet
 * saknas. Formateras för hand i stället för toLocaleString, som ger ett typografiskt minustecken.
 */
export const formatHours = (minutes: number | undefined | null): string => {
  if (minutes === undefined || minutes === null) return '';
  const sign = minutes < 0 ? '-' : '';
  return `${sign}${(Math.abs(minutes) / 60).toFixed(2).replace('.', ',')}`;
};
